import { createAction } from "@reduxjs/toolkit";
import { UnavailableIdJSON } from "_shared/_api/by-ids/by-ids-result";

/**
 * Records the ids a by-ids lookup answered as unavailable, and why.
 *
 * Its own module because both sides need it: `individual-api.ts` dispatches it from inside the
 * lookups, and `individuals-redux-slice.ts` reduces it. The slice already imports the API for its
 * matchers, so the API importing the slice back would be a cycle.
 *
 * `keyedBy` says which id space the ids are in: `individuals-by-userids` answers by user id,
 * `individuals-by-ids` by individual id.
 */
export const recordUnavailableIndividuals = createAction<{
  keyedBy: "userId" | "id";
  unavailable: UnavailableIdJSON[];
}>("individuals/recordUnavailable");
